import styled from "styled-components";

export const StyledTable = styled.div`

`

export const StyledNavigation = styled.div`
    display: flex;
    gap: 5px;
`

export const StyledNavItem = styled.div<{ isActive: boolean }>`
    display: flex;
    gap: 5px;
    font-family: ${({theme}) => theme.fonts.helvetica};
    font-weight: 700;
    font-size: clamp(14px, 1vw, 24px);
    padding: 10px clamp(10px, 3vw, 32px);
    border-radius: 20px 20px 0 0;
    background-color: ${(props) => props.isActive ? '#C2E5FF' : 'transparent'};
    color: ${(props) => props.isActive ? props.theme.colors.dark : props.theme.colors.lightGrey};
    cursor: pointer;

    &:hover {
        color: ${(props) => props.isActive ? props.theme.colors.dark : props.theme.colors.blue};

    }
`


export const StyleContent = styled.div`
    position: relative;
    //padding: clamp(10px, 3vw, 40px) 20px;
    background-color: #C2E5FF;
    padding: clamp(10px, 3vw, 40px) 0px;

    &:before {
        content: "";
        position: absolute;
        width: calc(100vw - 15px);
        background-color: #C2E5FF;
        top: 0;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: -1; /* Чтобы подложка оказалась под контентом */
    }

    //border-radius: 0 20px 20px 20px;
`